import { useEffect, useState } from "react";
import { navLinks, siteInfo } from "@/mocks/portal";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 w-full transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#top"
            className="flex items-center gap-2.5 cursor-pointer group"
            aria-label={`${siteInfo.name} 首页`}
          >
            <span
              className={`w-9 h-9 md:w-10 md:h-10 rounded-md flex items-center justify-center transition-colors ${
                solid ? "bg-primary-500 text-background-50" : "bg-background-50/15 text-background-50"
              }`}
            >
              <i className="ri-cursor-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading font-bold text-lg md:text-xl tracking-wide ${
                  solid ? "text-foreground-950" : "text-background-50 text-shadow-soft"
                }`}
              >
                {siteInfo.name}
              </span>
              <span
                className={`text-[10px] md:text-[11px] tracking-widest mt-0.5 ${
                  solid ? "text-foreground-500" : "text-background-100/80"
                }`}
              >
                内容直达门户
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-7" aria-label="主导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  solid
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-100 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#top"
              className="hidden md:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              <i className="ri-flashlight-fill"></i>
              立即直达
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
                solid ? "text-foreground-900 hover:bg-background-200" : "text-background-50 hover:bg-background-50/15"
              }`}
            >
              <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <nav className="px-4 py-3 flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-3 text-sm font-medium text-foreground-700 border-b border-background-200 last:border-0 cursor-pointer hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#top"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 cursor-pointer"
            >
              <i className="ri-flashlight-fill"></i>
              立即直达
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}